(function(){
'use strict';
const root=document.querySelector('.gs-v2');
if(!root||root.dataset.v2Ready)return;
root.dataset.v2Ready='1';
const $=s=>root.querySelector(s), $$=s=>Array.from(root.querySelectorAll(s));
const panelNames=['start','plan','options','price','final'];
let currentPanel='start';
function syncHeaderOffset(){const hd=document.querySelector('header.shopify-section-group-header-group')||document.querySelector('#header-group');const h=hd?Math.round(hd.getBoundingClientRect().height):0;root.style.setProperty('--gs-header-h',h+'px');}
syncHeaderOffset();window.addEventListener('resize',syncHeaderOffset);window.addEventListener('scroll',()=>{if(!root.dataset.hdSync){root.dataset.hdSync=1;requestAnimationFrame(()=>{syncHeaderOffset();delete root.dataset.hdSync;});}},{passive:true});
function scrollToConfigurator(){syncHeaderOffset();const anchor=root.querySelector('.gs-v2-progress')||root;anchor.style.scrollMarginTop='calc(var(--gs-header-h,0px) + 6px)';anchor.scrollIntoView({behavior:'smooth',block:'start'});}
function showPanel(name){
  const changed=name!==currentPanel; currentPanel=name;
  root.classList.toggle('v2-on-plan',name==='plan');
  if(changed&&name!=='start') setTimeout(scrollToConfigurator,30);
  if(name!=='plan') $('#v2-drawer')?.classList.remove('open');
  panelNames.forEach(n=>{const el=$('[data-v2-panel="'+n+'"]');if(el)el.hidden=n!==name;});
  $$('[data-v2-tab]').forEach(b=>b.classList.toggle('active',b.dataset.v2Tab===name));
  if(name==='plan') setTimeout(()=>{const f=$('#cf-fit');if(f)f.click();},80);
  if(name==='final') buildFinal();
}
$$('[data-v2-tab]').forEach(b=>b.addEventListener('click',()=>showPanel(b.dataset.v2Tab)));
$$('[data-v2-start]').forEach(b=>b.addEventListener('click',()=>{
  const a=b.dataset.v2Start;
  if(a==='ai'){$('#v2-ai')?.classList.add('open');$('#v2-ai')?.scrollIntoView({behavior:'smooth',block:'nearest'});return;}
  if(a==='model'){$('#v2-models')?.scrollIntoView({behavior:'smooth',block:'start'});return;}
  if(a==='free'){const n=$('#cf-free');if(n)n.click();showPanel('plan');setTimeout(()=>window.MKCfg?.setTool?.('room'),120);}
}));
function installReferencePlans(){
  /* La géométrie maître gs-geometry-v2.js est la seule source de vérité pour les modèles catalogue. */
  return true;
}

function selectModel(id){
  const s=$('#cf-model');
  const E=window.MKEngine;
  const houseModels=(E&&Array.isArray(E.MODELS))?E.MODELS:[];
  const model=houseModels.find(m=>m.id===id);
  const showError=(msg)=>{
    console.error('[Maison V2][open-model]',msg);
    const t=$('#cf-toast');
    if(t){t.textContent=msg;t.style.display='block';clearTimeout(t.__gsTimer);t.__gsTimer=setTimeout(()=>t.style.display='none',6000);}
  };
  if(!model){showError('Modèle '+id+' introuvable dans le moteur Maison.');return false;}
  if(!window.MKCfg||typeof window.MKCfg.selectModel!=='function'){
    showError('Moteur du configurateur non initialisé. Rechargez la page une fois.');
    return false;
  }
  let ok=false;
  try { ok=window.MKCfg.selectModel(id)===true; }
  catch(e){
    const msg=e&&e.message?e.message:String(e);
    showError('Impossible d’ouvrir '+model.label+' : '+msg);
    return false;
  }
  if(root.dataset.engineHealth==='error'){
    showError('Le moteur du configurateur a échoué son auto-test : '+(root.dataset.engineError||'erreur inconnue')+'.');
    return false;
  }
  if(!ok){
    const coreError=root.dataset.refreshError;
    showError('Le plan '+model.label+' n’a pas pu être chargé'+(coreError?' (erreur interface : '+coreError+')':'.'));
    return false;
  }
  if(s)s.value=id;
  root.dataset.selectedModel=id;
  showPanel('plan');
  setTimeout(()=>scrollToConfigurator(),40);
  return true;
}
const STYLES=[{k:'enduit',n:'Enduit',c:'#E9E5DC',cladding:'enduit-blanc',frame:'anthracite'},{k:'bois',n:'Bardage bois',c:'#B78C5C',cladding:'bardage-bois',frame:'anthracite'},{k:'composite',n:'Composite',c:'#3E4245',cladding:'bardage-anth',frame:'noir'}];
(function(){if(document.getElementById('gs-style-css'))return;const st=document.createElement('style');st.id='gs-style-css';st.textContent='.model-card .model-styles{display:flex;flex-wrap:wrap;gap:5px;margin:8px 0 10px}.model-card .model-styles .model-style{display:inline-flex!important;align-items:center;gap:5px;width:auto!important;min-height:0!important;margin:0!important;padding:6px 9px!important;border:1.5px solid #d9d5cb!important;border-radius:999px!important;background:#fff!important;font:600 11px/1 inherit!important;color:#1f2a24!important;cursor:pointer;box-shadow:none!important}.model-card .model-style i{width:12px;height:12px;border-radius:50%;border:1px solid rgba(0,0,0,.2);flex:0 0 auto}.model-card .model-styles .model-style[aria-pressed="true"]{border-color:#1f6b45!important;background:#eef6ef!important;color:#1f6b45!important}.model-card .model-card-image.styled{overflow:hidden;aspect-ratio:8/5;height:auto!important}.model-card .model-card-image.styled img{display:block!important;width:300%!important;max-width:none!important;height:100%!important;object-fit:fill!important;transition:transform .25s ease}';document.head.appendChild(st);})();
function buildModels(){
  const grid=$('#v2-model-grid'), s=$('#cf-model'); if(!grid||!s)return;
  /* cartes mises à jour le 06/10 : gamme renommée selon la surface habitable réelle, vues 3D des nouveaux plans (images du thème) */
  const cardBase=(()=>{const sc=document.querySelector('script[src*="gs-config-v2-v8"]');const u=sc&&sc.src||'';const i=u.lastIndexOf('/');return i>0?[u.slice(0,i+1),(u.split('?')[1]||'')]:null;})();
  const cardImg=id=>cardBase?cardBase[0]+'gs-card-'+id+'.jpg'+(cardBase[1]?'?'+cardBase[1]:''):'';
  const data=window.GS_CARD_DATA||[["gs70-l","GS65 L","66 m² habitables","2 chambres"],["gs70-rect","GS65 Rect.","64 m² habitables","2 chambres"],["gs80-l","GS80 L","82 m² habitables","3 chambres"],["gs80-rect","GS80 Rect.","80 m² habitables","3 chambres"],["gs90-l","GS95 L","97 m² habitables","3 chambres + bureau"],["gs90-rect","GS95 Rect.","93 m² habitables","3 chambres + bureau"],["gs100-l","GS100 L","102 m² habitables","3 chambres + bureau"],["gs100-rect","GS100 Rect.","98 m² habitables","3 chambres + bureau"],["gs120-l","GS115 L","118 m² habitables","3 chambres + bureau + pièce technique"],["gs120-rect","GS115 Rect.","114 m² habitables","3 chambres + bureau + pièce technique"]].map(x=>x.concat([cardImg(x[0])]));
  grid.innerHTML='';
  data.forEach(x=>{
    const o=Array.from(s.options).find(v=>v.value===x[0]); if(!o)return;
    const card=document.createElement('article');card.className='model-card';card.dataset.model=x[0];
    /* 06/10 : un visuel par modèle et par finition (même maison, même caméra, seule la façade change).
       Une planche gs-styles-<modèle>.jpg contient les finitions côte à côte, dans l'ordre de STYLES. */
    const sheet=cardBase?cardBase[0]+'gs-styles-'+x[0]+'.jpg'+(cardBase[1]?'?'+cardBase[1]:''):'';
    card.dataset.style=STYLES[0].k;
    card.innerHTML='<div class="model-card-image styled"><img src="'+(sheet||x[4])+'" alt="'+x[1]+' — '+STYLES[0].n+'" loading="lazy"></div><div class="model-card-copy"><strong>'+x[1]+'</strong><span>'+x[2]+'</span><small>'+x[3]+'</small><div class="model-styles" role="group" aria-label="Style de façade">'+STYLES.map((st,i)=>'<button type="button" class="model-style" data-style="'+st.k+'" aria-pressed="'+(i===0)+'"><i style="background:'+st.c+'"></i>'+st.n+'</button>').join('')+'</div><button type="button" class="model-open">Choisir ce modèle →</button></div>';
    const im=card.querySelector('img'),box=card.querySelector('.model-card-image'); im.onerror=()=>{im.onerror=null;box.classList.remove('styled');card.querySelector('.model-styles').hidden=true;im.style.transform='';im.src=x[4];};
    card.querySelectorAll('.model-style').forEach(b=>b.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();const k=STYLES.findIndex(q=>q.k===b.dataset.style),st=STYLES[k];card.dataset.style=st.k;card.querySelectorAll('.model-style').forEach(q=>q.setAttribute('aria-pressed',String(q===b)));im.style.transform='translateX(-'+(k*100/STYLES.length)+'%)';im.alt=x[1]+' — '+st.n;}));
    card.querySelector('.model-open').addEventListener('click',(e)=>{e.preventDefault();e.stopPropagation();const st=STYLES.find(q=>q.k===card.dataset.style)||STYLES[0];if(selectModel(x[0])!==false){try{window.MKCfg.commit(()=>{const P=window.MKCfg.P();P.opts.cladding=st.cladding;P.opts.cladding2=null;P.opts.frame=st.frame;});}catch(_){}}});
    grid.appendChild(card);
  });
  const prices=modelPrices(); const vals=Object.values(prices).filter(v=>v>0);
  if(vals.length) $('#v2-start-price').textContent=fmt(Math.min(...vals));
  grid.querySelectorAll('.model-card').forEach((c,i)=>{const id=c.dataset.model;if(id&&prices[id]){const sm=document.createElement('em');sm.className='model-card-price';sm.textContent='dès '+fmt(prices[id])+' HT';c.querySelector('.model-card-copy small')?.after(sm);}});
}
function modelPrices(){
  const E=window.MKEngine, cfg=window.MKCfg; if(!E||!cfg||!cfg.db)return {};
  const out={};
  (E.MODELS||[]).forEach(m=>{try{const T=E.newProject();E.applyModel(T,m);const Q=E.quote(E.compute(T,cfg.db()),T.opts.formula);out[m.id]=Q.ht;}catch(e){}});
  return out;
}
function fmt(n){if(!Number.isFinite(n))return '—';return new Intl.NumberFormat('fr-FR',{maximumFractionDigits:0}).format(n)+' €';}function runtimeSelfTest(){
  const E=window.MKEngine;
  if(!E||!Array.isArray(E.MODELS)||!E.MODELS.length)return false;
  try{
    const m=E.MODELS.find(x=>x.id==='gs70-l')||E.MODELS[0];
    const T=E.newProject();
    E.applyModel(T,m);
    const C=E.compute(T,E.mergeDb(window.MK_DB));
    if(!T.rooms.length||!T.walls.length||!C)throw new Error('Le moteur n’a pas produit un plan valide.');
    root.dataset.engineHealth='ok';
    delete root.dataset.engineError;
    return true;
  }catch(e){
    root.dataset.engineHealth='error';
    root.dataset.engineError=String(e&&e.message||e);
    console.error('[Maison V2][self-test]',e);
    const t=$('#cf-toast');
    if(t){t.textContent='Erreur moteur configurateur : '+root.dataset.engineError;t.style.display='block';}
    return false;
  }
}

function updateHabitableArea(){
  const el=$('#v2-habitable-area'),P=window.MKCfg?.P?.();
  if(!el||!P)return;
  const C=(window.MKCfg?.Ctot||window.MKCfg?.C)?.(); /* 08/10 : à l'étage, on garde la surface et le prix de la maison (calcul RDC) */
  let total=0;
  const rooms=(C&&Array.isArray(C.rooms)&&C.rooms.length)?C.rooms:[];
  rooms.forEach(r=>{
    const a=Number(r.area);
    if(Number.isFinite(a)&&a>0&&r.type!=='garage')total+=a;
  });
  if(P.model==='gs80-l' && total<50 && window.MKEngine?.GS_PLANS?.['gs80-l']){
    const G=window.MKEngine.GS_PLANS['gs80-l'];
    let catalog=0;
    (G.rooms||[]).forEach(r=>{
      const a=Number(r[4]),t=String(r[3]||'');
      if(Number.isFinite(a)&&a>0&&!/^(garage|autre)$/i.test(t))catalog+=a;
    });
    if(catalog>0)total=catalog;
  }
  /* 08/10 : la surface habitable inclut l'étage quand il existe */
  try{(window.MKCfg?.upperRooms?.()||[]).forEach(r=>{const a=Number(r.area);if(Number.isFinite(a)&&a>0&&r.type!=='garage')total+=a;});}catch(_){}
  el.textContent=total>0?total.toLocaleString('fr-FR',{minimumFractionDigits:1,maximumFractionDigits:1})+' m²':'— m²';
}
function updatePrice(){
  updateHabitableArea();
  const Q=window.MKCfg&&window.MKCfg.quote?window.MKCfg.quote():null;
  const display=Q&&Q.ht>0?fmt(Q.ht):'—';
  const tn=$('#v2-transport-note'); if(tn&&Q){const db=window.MKCfg.db().params; tn.textContent=Q.transport!=null?'Transport : '+fmt(Q.transport)+' HT ('+(db.transportRoundTrip?'aller-retour, ':'')+String(db.transportKm).replace('.',',')+' €/km).':'Renseignez la distance pour chiffrer le transport.';}
  ['#v2-live-price','#v2-option-price','#v2-price-total'].forEach(id=>{const e=$(id);if(e)e.textContent=display;});
  const a=$('#v2-area');const surf=$('#cf-surf')?.textContent.match(/([\d\s,.]+)\s*m²/i);if(a&&surf)a.textContent=surf[1].replace(/\s/g,' ')+' m²';
}
const quoteObs=new MutationObserver(updatePrice);quoteObs.observe($('#cf-quote')||root,{subtree:true,childList:true,characterData:true});
$$('[data-v2-view]').forEach(b=>b.addEventListener('click',()=>{
  $$('[data-v2-view]').forEach(x=>x.classList.toggle('active',x===b));
  const c2=$('#cf-canvas'),c3=$('#cf-3d');
  if(b.dataset.v2View==='3d'){if(c2)c2.hidden=true;if(c3)c3.hidden=false;Promise.resolve(window.MKCfg?.setMode?.('3d')).then(()=>{try{window.MKCfg?.setView?.('iso');}catch(e){}});}
  else{if(c3)c3.hidden=true;if(c2)c2.hidden=false;window.MKCfg?.setMode?.('2d');}
}));
$$('[data-v2-bottom]').forEach(b=>b.addEventListener('click',()=>{
  const a=b.dataset.v2Bottom;
  $$('[data-v2-bottom]').forEach(x=>x.classList.toggle('active',x===b));
  if(a==='plan'){showPanel('plan');$('#v2-drawer')?.classList.remove('open');}
  else{showPanel('plan');const map={rooms:['v2-rooms-panel','Vos pièces','Nom, type et surface'],openings:['v2-openings-panel','Ouvertures','Portes, fenêtres et baies'],furniture:['v2-furniture-panel','Mobilier','Ajouter puis déplacer sur le plan'],options:['v2-options-panel','Options','Modèle, niveaux, toiture, finitions']};const m=map[a];if(m){root.querySelectorAll('.drawer-section').forEach(x=>x.hidden=x.id!==m[0]);const d=$('#v2-drawer');if(d){d.dataset.section=a;d.classList.add('open');}const t=$('#v2-drawer-title'),st=$('#v2-drawer-sub');if(t)t.textContent=m[1];if(st)st.textContent=m[2];}}
}));
$('#v2-drawer-close')?.addEventListener('click',()=>{$('#v2-drawer')?.classList.remove('open');$$('[data-v2-bottom]').forEach(x=>x.classList.toggle('active',x.dataset.v2Bottom==='plan'));});
$('#v2-delete')?.addEventListener('click',()=>{if(window.MKCfg?.deleteSelected)window.MKCfg.deleteSelected();});
$$('[data-tool]').forEach(b=>b.addEventListener('click',()=>{$$('[data-tool]').forEach(x=>x.classList.toggle('active',x.dataset.tool===b.dataset.tool));}));
$('#v2-ai-skip')?.addEventListener('click',()=>{$('#v2-models')?.scrollIntoView({behavior:'smooth',block:'start'});});
$$('[data-ai-model]').forEach(c=>c.addEventListener('click',()=>selectModel(c.dataset.aiModel)));
$('#v2-ai-go')?.addEventListener('click',()=>{
  const t=($('#v2-ai-input')?.value||'').toLowerCase();
  const models=(window.MKEngine&&window.MKEngine.MODELS)||[];
  const wantL=/\ben l\b|forme l|en équerre|\bl\b/.test(t), wantRect=/rectang/.test(t);
  const mA=t.match(/(\d{2,3})\s*(m²|m2|m\b|mètres)/)||t.match(/\b(\d{2,3})\b/);
  const mC=t.match(/(\d)\s*chambre/); const ch=mC?parseInt(mC[1],10):null;
  const area=mA?parseInt(mA[1],10):(/petite|compacte/.test(t)?70:/grande|famille/.test(t)?120:ch?(ch<=2?70:ch===3?90:120):100); const bureau=/bureau/.test(t);
  let best=null,score=1e9;
  models.forEach(m=>{let sc=Math.abs((m.area||0)-area);
    if(wantL&&m.shape!=='L')sc+=15; if(wantRect&&m.shape!=='rect')sc+=15;
    const lab=(m.label||'').toLowerCase(); const mc=lab.match(/(\d) chambre/); if(ch&&mc&&parseInt(mc[1],10)<ch)sc+=25; if(bureau&&!/bureau/.test(lab))sc+=10;
    if(sc<score){score=sc;best=m;}});
  const id=best?best.id:'';
  const ok=selectModel(id);
  const note=$('#v2-ai-note');
  if(note)note.textContent=ok?'Base sélectionnée : '+(best&&best.label||id)+'. Vous pouvez maintenant modifier chaque pièce, mur et ouverture.':'Décrivez votre surface ou choisissez une proposition ci-dessous.';
});
$$('[data-service]').forEach(c=>c.addEventListener('change',()=>{
  const list=$$('[data-service]').filter(x=>x.checked).map(x=>x.closest('label')?.querySelector('b')?.textContent||x.dataset.service);
  window.MKCfg?.commit?.(()=>{window.MKCfg.P().opts.services=list;});updatePrice();}));
function syncServices(){const P=window.MKCfg?.P?.();if(!P)return;const l=P.opts.services||[];$$('[data-service]').forEach(x=>{const n=x.closest('label')?.querySelector('b')?.textContent||x.dataset.service;x.checked=l.indexOf(n)>=0;});const k=$('#q-km');if(k&&document.activeElement!==k)k.value=P.opts.distanceKm==null?'':P.opts.distanceKm;}
function buildFinal(){
  const box=$('#v2-final-summary');if(!box)return;
  const area=$('#v2-area')?.textContent||'—';const price=$('#v2-price-total')?.textContent||'—';const name=($('#cf-name')?.value||'Mon projet').replace(/[&<>"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'})[c]);
  box.innerHTML='<div style="font-size:18px;font-weight:900">'+name+'</div><div style="margin-top:8px;color:#69756e;font-size:12px">'+area+'</div><div style="margin-top:14px;font-size:24px;font-weight:900;color:#176b4d">'+price+'</div><div style="margin-top:4px;color:#69756e;font-size:10px">prix HT indicatif, hors prestations à chiffrer</div>';
}
$('#v2-final-quote')?.addEventListener('click',()=>window.MKCfg?.openQuote?.());
$('#v2-save')?.addEventListener('click',()=>$('#cf-proj')?.click());
$('#q-km')?.addEventListener('change',e=>{const v=e.target.value===''?null:Math.max(0,+e.target.value);window.MKCfg?.commit?.(()=>{window.MKCfg.P().opts.distanceKm=v;});updatePrice();});
const s=$('#cf-model');
if(s)new MutationObserver(buildModels).observe(s,{childList:true,subtree:true});
let modelBuildTries=0;
(function waitForModelEngine(){
  buildModels();
  if(!root.querySelector('.model-card')&&modelBuildTries++<40)setTimeout(waitForModelEngine,250);
})();
setTimeout(runtimeSelfTest,120);
setTimeout(updatePrice,1200);
function roomAreaApprox(P,r){
  const by=id=>P.walls.find(w=>w.id===id);
  const N=by(r.n),S=by(r.s),W=by(r.w),E=by(r.e);
  if(!N||!S||!W||!E)return 0;
  const w=Math.max(0,Math.min(Math.abs(N.x2-N.x1),Math.abs(S.x2-S.x1)));
  const d=Math.max(0,Math.min(Math.abs(W.y2-W.y1),Math.abs(E.y2-E.y1)));
  const tM=Number(P.thick?.mur||25),tC=Number(P.thick?.cloison||11);
  const tX=(N.t===tC||S.t===tC?tC:tM),tY=(W.t===tC||E.t===tC?tC:tM);
  return Math.max(0,(w-tX)*(d-tY))/10000;
}
function renderRooms(){
  const list=$('#v2-room-list'),count=$('#v2-room-count'),P=window.MKCfg?.P?.();
  if(!list||!P)return;
  const rooms=P.rooms||[];
  if(count)count.textContent=String(rooms.length);
  list.innerHTML='';
  if(!rooms.length){list.innerHTML='<div class="v2-room-empty">Choisissez un modèle ou dessinez une première pièce.</div>';return;}
  const types=[['autre','Autre'],['sejour','Séjour / salon'],['cuisine','Cuisine'],['chambre','Chambre'],['bureau','Bureau'],['sdb','Salle de bains'],['wc','WC'],['buanderie','Buanderie / cellier'],['entree','Entrée'],['dressing','Dressing'],['garage','Garage']];
  rooms.forEach((r,i)=>{
    const row=document.createElement('div');row.className='v2-room-row';row.dataset.roomId=r.id;
    /* surface exacte du moteur (même valeur que sur le plan), repli sur l'approximation */
    const cr=((window.MKCfg.C&&window.MKCfg.C()||{}).rooms||[]).find(x=>x.id===r.id);
    const area=cr?cr.area:roomAreaApprox(P,r);
    const safeName=String(r.name||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
    row.innerHTML='<div class="room-index">'+(i+1)+'</div><div class="room-fields"><input class="v2-room-name" type="text" maxlength="50" value="'+safeName+'" aria-label="Nom de la pièce '+(i+1)+'"><select class="v2-room-type" aria-label="Type de pièce">'+types.map(t=>'<option value="'+t[0]+'"'+(r.type===t[0]?' selected':'')+'>'+t[1]+'</option>').join('')+'</select></div><div class="room-area">'+(area?area.toLocaleString('fr-FR',{maximumFractionDigits:1}):'—')+' m²</div>';
    const name=row.querySelector('.v2-room-name'),type=row.querySelector('.v2-room-type');
    name.addEventListener('change',()=>{
      const v=name.value.trim()||('Pièce '+(i+1));
      window.MKCfg?.commit?.(()=>{const rr=window.MKCfg.P().rooms.find(x=>x.id===r.id);if(rr)rr.name=v;});
    });
    type.addEventListener('change',()=>{
      const v=type.value;
      window.MKCfg?.commit?.(()=>{const rr=window.MKCfg.P().rooms.find(x=>x.id===r.id);if(rr)rr.type=v;});
    });
    row.addEventListener('click',e=>{if(e.target.closest('input,select'))return;window.MKCfg?.sel?.({t:'room',id:r.id});});
    list.appendChild(row);
  });
}
$('#v2-auto-furnish')?.addEventListener('click',()=>{$('#cf-furn-auto')?.click();setTimeout(renderRooms,80);});
window.addEventListener('mk:project-changed',()=>{syncServices();updatePrice();});
window.addEventListener('mk:project-changed',()=>setTimeout(renderRooms,0));
setTimeout(renderRooms,700);
setTimeout(renderRooms,1600);
/* GS_WALL_DRAG_EDITOR_V1 */
(function(){
  var canvas=document.getElementById('cf-canvas');
  if(!canvas||canvas.__gsWallEditor)return;
  canvas.__gsWallEditor=true;
  var drag=null, raf=0, lastX=0,lastY=0;

  function P(){return window.MKCfg&&window.MKCfg.P?window.MKCfg.P():null;}
  function worldFromEvent(e){
    var p=P(); if(!p||!p.walls||!p.walls.length)return null;
    var r=canvas.getBoundingClientRect();
    var px=(e.clientX-r.left)*(canvas.width/r.width);
    var py=(e.clientY-r.top)*(canvas.height/r.height);
    var minX=Infinity,minY=Infinity,maxX=-Infinity,maxY=-Infinity;
    p.walls.forEach(function(w){
      minX=Math.min(minX,w.x1,w.x2); maxX=Math.max(maxX,w.x1,w.x2);
      minY=Math.min(minY,w.y1,w.y2); maxY=Math.max(maxY,w.y1,w.y2);
    });
    var pad=42, sx=(canvas.width-pad*2)/Math.max(1,maxX-minX), sy=(canvas.height-pad*2)/Math.max(1,maxY-minY);
    var s=Math.min(sx,sy);
    var ox=(canvas.width-(maxX-minX)*s)/2-minX*s;
    var oy=(canvas.height-(maxY-minY)*s)/2-minY*s;
    return {x:(px-ox)/s,y:(py-oy)/s,s:s};
  }
  function nearestWall(e){
    var p=P(),q=worldFromEvent(e); if(!p||!q)return null;
    var best=null,bd=Infinity;
    p.walls.forEach(function(w){
      var dx=w.x2-w.x1,dy=w.y2-w.y1,len2=dx*dx+dy*dy;
      if(len2<1)return;
      var t=((q.x-w.x1)*dx+(q.y-w.y1)*dy)/len2;t=Math.max(0,Math.min(1,t));
      var x=w.x1+t*dx,y=w.y1+t*dy,d=Math.hypot(q.x-x,q.y-y);
      if(d<bd){bd=d;best={w:w,d:d,q:q};}
    });
    return best&&best.d<35?best:null;
  }
  function snap(v){return Math.round(v/5)*5;}
  function selectWall(w){
    try{window.MKCfg.sel({t:'wall',id:w.id});}catch(e){}
    canvas.classList.add('gs-wall-selected');
    canvas.setAttribute('aria-label','Mur sélectionné — faites glisser pour le déplacer');
    var hint=document.getElementById('cf-hint');
    if(hint){hint.textContent='Mur sélectionné : faites glisser pour le déplacer';hint.style.display='block';}
  }
  function moveWall(w,dx,dy){
    var p=P(); if(!p||!w)return;
    if(Math.abs(w.y2-w.y1)<1){dy=snap(dy);dx=0;}
    else if(Math.abs(w.x2-w.x1)<1){dx=snap(dx);dy=0;}
    else return;
    if(!dx&&!dy)return;
    w.x1+=dx;w.x2+=dx;w.y1+=dy;w.y2+=dy;
    if(raf)return;
    raf=requestAnimationFrame(function(){
      raf=0;
      try{window.MKCfg.commit(function(){});}catch(e){}
    });
  }
  canvas.addEventListener('pointerdown',function(e){
    /* 08/10 : le moteur gère lui-même le glisser des murs (murs liés, contrôle des pièces/ouvertures) ; cette ancienne couche entrait en conflit et annulait le déplacement */
    if(window.MKCfg&&window.MKCfg.coreWallDrag)return;
    if(e.button!==0)return;
    var activeTool=document.querySelector('.gs-v2 [data-tool].active');
    if(activeTool&&activeTool.dataset.tool!=='select')return;
    var hit=nearestWall(e);
    if(!hit)return;
    e.preventDefault();
    var p=P(); if(!p)return;
    selectWall(hit.w);
    var q=hit.q;
    drag={id:hit.w.id,x:q.x,y:q.y,wx:hit.w.x1,wy:hit.w.y1};
    canvas.setPointerCapture&&canvas.setPointerCapture(e.pointerId);
    canvas.classList.add('gs-wall-dragging');
  });
  canvas.addEventListener('pointermove',function(e){
    if(!drag)return;
    var q=worldFromEvent(e); if(!q)return;
    var w=P().walls.find(function(x){return x.id===drag.id;}); if(!w)return;
    var dx=q.x-drag.x,dy=q.y-drag.y;
    var sx=Math.abs(w.y2-w.y1)<1?snap(dx):0;
    var sy=Math.abs(w.x2-w.x1)<1?snap(dy):0;
    var total=(sx||sy);
    if(!total)return;
    var nx=drag.wx+sx,ny=drag.wy+sy;
    var stepX=nx-w.x1,stepY=ny-w.y1;
    if(stepX||stepY)moveWall(w,stepX,stepY);
    drag.x=q.x;drag.y=q.y;drag.wx=w.x1;drag.wy=w.y1;
  });
  function end(e){
    if(!drag)return;
    try{canvas.releasePointerCapture&&canvas.releasePointerCapture(e.pointerId);}catch(x){}
    drag=null;canvas.classList.remove('gs-wall-dragging');
    try{window.MKCfg.commit(function(){});}catch(x){}
    var hint=document.getElementById('cf-hint');if(hint)hint.textContent='Mur sélectionné : faites glisser pour le déplacer';
  }
  canvas.addEventListener('pointerup',end);
  canvas.addEventListener('pointercancel',end);
  canvas.addEventListener('pointerleave',function(){});
})();

showPanel('start');
})();